import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getRescueSelector } from '../../procedures/rescue/selectors'
import { IRescueState } from '../../procedures/rescue/store/rescue.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'

export function* addRescueItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const rescueState: IRescueState = yield select(getRescueSelector)
  const { pta, addToTimeline, key, time, date, assessedBy, comments, isEkgImport } = rescueState
  if (addToTimeline) {
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Rescue',
      eventSubHeader: `By ${assessedBy?.name || ''},
      Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_RESCUE_PROCEDURE_ITEM,
      defaultHref: TabConstants.RESCUE_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addRescueItemSaga() {
  yield takeLatest([TimelineConstants.ADD_RESCUE_ITEM], addRescueItem)
}
